import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {Home365LoaderComponent} from "./home365-loader.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

@NgModule({
  declarations: [Home365LoaderComponent],
  exports: [Home365LoaderComponent],
  imports: [CommonModule, MatProgressSpinnerModule],
})
export class Home365LoaderModule {}
